import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EReportColumnHeader,
  IReportingCategoriesTableResponse,
  EParamChannelTypeGlobal,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACategoriesReportTableFilters,
  TPPAdvertiserId,
  TSPCategoriesReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingCategoriesTableV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TDACategoriesReportTableFilters | TSPCategoriesReportTableFilters) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingCategoriesTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCategoriesTable_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserCategoriesReportTable(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
